/**
 * Enum de tipos de tema - sincronizado com backend ThemeType.cs
 * Cada valor numérico corresponde ao enum no .NET
 */
export const ThemeType = {
  DEFAULT: 1,
  BARBERSHOP: 2,
  CLINIC: 3,
  TATTOO_STUDIO: 4,
  BEAUTY_SALON: 5,
  PSYCHOLOGY: 6,
  AESTHETICS: 7,
  MASSAGE: 8,
  DENTAL: 9,
  MEDICAL: 10,
  THERAPY: 11,
};

/**
 * Mapeamento de ThemeType (número) para Theme ID (string)
 * Usado para carregar o JSON correto
 */
export const ThemeTypeToId = {
  [ThemeType.DEFAULT]: 'default',
  [ThemeType.BARBERSHOP]: 'barbershop',
  [ThemeType.CLINIC]: 'clinic',
  [ThemeType.TATTOO_STUDIO]: 'tattoo-studio',
  [ThemeType.BEAUTY_SALON]: 'beauty-salon',
  [ThemeType.PSYCHOLOGY]: 'psychology',
  [ThemeType.AESTHETICS]: 'aesthetics',
  [ThemeType.MASSAGE]: 'massage',
  [ThemeType.DENTAL]: 'dental',
  [ThemeType.MEDICAL]: 'medical',
  [ThemeType.THERAPY]: 'therapy',
};

/**
 * Mapeamento de Theme ID (string) para ThemeType (número)
 * Usado para salvar no backend
 */
export const ThemeIdToType = {
  'default': ThemeType.DEFAULT,
  'barbershop': ThemeType.BARBERSHOP,
  'clinic': ThemeType.CLINIC,
  'tattoo-studio': ThemeType.TATTOO_STUDIO,
  'beauty-salon': ThemeType.BEAUTY_SALON,
  'psychology': ThemeType.PSYCHOLOGY,
  'aesthetics': ThemeType.AESTHETICS,
  'massage': ThemeType.MASSAGE,
  'dental': ThemeType.DENTAL,
  'medical': ThemeType.MEDICAL,
  'therapy': ThemeType.THERAPY,
};

/**
 * Nomes amigáveis dos temas
 */
export const ThemeDisplayNames = {
  [ThemeType.DEFAULT]: 'Outro',
  [ThemeType.BARBERSHOP]: 'Barbearia',
  [ThemeType.CLINIC]: 'Clínica Multidisciplinar',
  [ThemeType.TATTOO_STUDIO]: 'Studio de Tatuagem',
  [ThemeType.BEAUTY_SALON]: 'Salão de Beleza',
  [ThemeType.PSYCHOLOGY]: 'Psicologia',
  [ThemeType.AESTHETICS]: 'Estética',
  [ThemeType.MASSAGE]: 'Massoterapia',
  [ThemeType.DENTAL]: 'Odontologia',
  [ThemeType.MEDICAL]: 'Clínica Médica',
  [ThemeType.THERAPY]: 'Terapias Holísticas',
};

/**
 * Lista de todos os temas disponíveis para seleção
 * Usado na tela de primeira escolha
 */
export const AvailableThemes = [
  { type: ThemeType.BARBERSHOP, id: 'barbershop', name: 'Barbearia' },
  { type: ThemeType.CLINIC, id: 'clinic', name: 'Clínica Multidisciplinar' },
  { type: ThemeType.TATTOO_STUDIO, id: 'tattoo-studio', name: 'Studio de Tatuagem' },
  { type: ThemeType.BEAUTY_SALON, id: 'beauty-salon', name: 'Salão de Beleza' },
  { type: ThemeType.PSYCHOLOGY, id: 'psychology', name: 'Psicologia' },
  { type: ThemeType.AESTHETICS, id: 'aesthetics', name: 'Estética' },
  { type: ThemeType.MASSAGE, id: 'massage', name: 'Massoterapia' },
  { type: ThemeType.DENTAL, id: 'dental', name: 'Odontologia' },
  { type: ThemeType.MEDICAL, id: 'medical', name: 'Clínica Médica' },
  { type: ThemeType.THERAPY, id: 'therapy', name: 'Terapias Holísticas' },
  { type: ThemeType.DEFAULT, id: 'default', name: 'Outro' },
];

/**
 * Converte ThemeType (número) para Theme ID (string)
 * @param {number} themeType - Valor do enum ThemeType
 * @returns {string} Theme ID
 */
export function themeTypeToId(themeType) {
  return ThemeTypeToId[themeType] || 'default';
}

/**
 * Converte Theme ID (string) para ThemeType (número)
 * @param {string} themeId - ID do tema
 * @returns {number} Valor do enum ThemeType
 */
export function themeIdToType(themeId) {
  return ThemeIdToType[themeId] || ThemeType.DEFAULT;
}

/**
 * Obtém o nome amigável de um tema
 * @param {number} themeType - Valor do enum ThemeType
 * @returns {string} Nome do tema
 */
export function getThemeDisplayName(themeType) {
  return ThemeDisplayNames[themeType] || 'Padrão';
}
